import React, { Ref } from 'react'
import { TextArea } from '@paypalcorp/pp-react'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { useAppSelector } from '../../../store/hooks'
import { selectDescription } from '../../../store/slices/groupFormSlice'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'

interface DescriptionProps {
  error?: string
  handleOnChange: Function
  descriptionRef?: Ref<HTMLTextAreaElement>
}

const GroupDescription = (props: DescriptionProps) => {
  const description = useAppSelector(selectDescription)
  const { getContent } = useLocalizedContent()
  const maxCharacters = 250

  const handleDescriptionChange = (
    evt: React.ChangeEvent<HTMLInputElement>,
  ) => {
    props.handleOnChange(evt.target.value)
  }

  return (
    <TextArea
      name="description"
      value={description}
      label={getContent('create.view.description')}
      onChange={handleDescriptionChange}
      showCharacterCounter={!isCoverOnCreateFlowEnabled()}
      maxCharacters={maxCharacters}
      data-testid="group-description-input"
      errorText={props.error}
      maxRows={isCoverOnCreateFlowEnabled() ? 4 : 6}
      ref={props.descriptionRef}
    />
  )
}
export default GroupDescription
